import React from 'react'

/**
 * @see https://tanstack.com/query/latest/docs/framework/react/devtools#devtools-in-production for implementation
 */
const _ReactQueryDevtoolsProduction = React.lazy(() =>
  import('@tanstack/react-query-devtools/build/modern/production.js').then((d) => ({
    default: d.ReactQueryDevtools,
  })),
)

export interface ReactQueryDevToolsProductionProps {}

export const ReactQueryDevToolsProduction: React.FC<ReactQueryDevToolsProductionProps> = ({}) => {
  return (
    <React.Suspense fallback={null}>
      <_ReactQueryDevtoolsProduction />
    </React.Suspense>
  )
}
